export const scrollToId = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -76 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const trackEvent = (event, props = {}) => {
  try {
    window.posthog && window.posthog.capture(event, props);
  } catch (e) {}
};
